/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-pin.js
 *
 * 指定した要素を固定するスクロールアニメーション用
 *
 * 目次
 * __00: 初期設定
 * __10: タイトル
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 
 * __00: 初期設定
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
function setWindowHeight() {
  var setWH = window.innerHeight;
  return setWH;
}

/**
 * 
 * __10: タイトル
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function homeScroll() {
  const agent = window.navigator.userAgent.toLowerCase()
  let WindowHeight = setWindowHeight();
  let siteMv = document.getElementById("site-mv");
  let footer = document.getElementById("footer");
  let mvImageCover = document.getElementById("mvImageCover");
  var mvCircle = document.getElementById('mvCircle');
  var mvPageNavShaft = document.getElementById('mvPageNavShaft');
  var mvPageNavLabel = document.querySelectorAll("#mvPageNav .list-label");
  let mvCopyText = document.querySelectorAll("#mvCopy p span:not(.copy__line)");
  let mvCopyBorder = document.querySelectorAll("#mvCopy .copy__line");
  let mvLeadText = document.querySelectorAll("#mvLead p span:not(.shadow)");
  let mvScrollDown = document.getElementById('mvScrollDown');
  let siteContentsImg = document.querySelectorAll(".site-contents .concept-img");
  let siteContentsBg = document.querySelectorAll(".site-contents.contents-bg");

  window.addEventListener("DOMContentLoaded", () => {
    const agent = window.navigator.userAgent.toLowerCase()

    //TOP MVスクロールアニメーション発動条件
    const siteMvtoggle = () => {
      if (window.pageYOffset < WindowHeight) {
        siteMV()
      } else {
        window.addEventListener("scroll", function () {
          if (window.pageYOffset == 0) {
            siteMV()
          }
        })
      }
    }

    if (agent.indexOf("msie") != -1 || agent.indexOf("trident") != -1) {
      siteMvtoggle()
    } else if (agent.indexOf("edg") != -1 || agent.indexOf("edge") != -1) {
      siteMvtoggle()
    } else if (agent.indexOf("opr") != -1 || agent.indexOf("opera") != -1) {
      siteMvtoggle()
    } else if (agent.indexOf("chrome") != -1) {
      siteMvtoggle()
    } else if (agent.indexOf("safari") != -1) {
      console.log('safari');
    } else if (agent.indexOf("firefox") != -1) {
      siteMvtoggle()
    } else if (agent.indexOf("opr") != -1 || agent.indexOf("opera") != -1) {
      siteMvtoggle()
    }
    siteHome()
  });

  function siteMV() {

    /**
     * TOP MV クール
     */
    let siteMvScrollTl = gsap.timeline();

    ScrollTrigger.create({
      animation: siteMvScrollTl,
      trigger: siteMv,
      start: `15% top`,
      end: `75% top`,
      scrub: 2,
      // markers: true,
    })

    siteMvScrollTl
      .to([mvCopyText, mvLeadText], {
        opacity: 0,
        yPercent: -50,
        stagger: {
          from: "start",
          amount: 1
        }
      })
      .to([mvPageNavLabel], {
        opacity: 0,
        duration: 1,
      }, "<")
      .to([mvCopyBorder], {
        scaleX: 0,
      }, "<")
      .to([mvScrollDown], {
        opacity: 0,
      }, "<")
      .to([mvCircle], {
        opacity: 0,
      }, "<")
      .to([mvPageNavShaft], {
        scale: 0.1,
        rotateZ: -180,
        opacity: 0,
        duration: 3,
      }, "<");
  }

  function siteHome() {
    gsap.set([mvImageCover], { opacity: 0 });

    /**
     * 影 1クール
     */
    let siteMvShadowTl1 = gsap.timeline();

    ScrollTrigger.create({
      animation: siteMvShadowTl1,
      trigger: siteMv,
      start: `10% top`,
      end: `30% top`,
      scrub: 2,
      // markers: true,
    })

    siteMvShadowTl1.to(mvImageCover, { opacity: 0.8 });

    /**
     * 影 2クール
     */
    let siteMvShadowTl2 = gsap.timeline();

    ScrollTrigger.create({
      animation: siteMvShadowTl2,
      trigger: footer,
      start: `top 75%`,
      end: `25% 75%`,
      scrub: 2,
      // markers: true,
    })

    siteMvShadowTl2.to(mvImageCover, { opacity: 1 });

    /**
     * TOP クール
     */
    let homeScrollTl = gsap.timeline();

    ScrollTrigger.create({
      animation: homeScrollTl,
      trigger: siteContentsBg,
      start: `15% 75%`,
      end: `65% 75%`,
      scrub: 2,
      // markers: true,
    })

    homeScrollTl.to([siteContentsImg], {
      opacity: 1,
    })
  }
}

/**
 * 
 * __10: タイトル
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function tllShadow() {
  let tllShadow = document.getElementById("tllShadow");
  let tllShadowInner = document.getElementById("tllShadowInner");

  gsap.set([tllShadow, tllShadowInner], { opacity: 0 });

  /**
   * 影 1クール
   */
  let tllShadowTL1 = gsap.timeline();

  ScrollTrigger.create({
    animation: tllShadowTL1,
    trigger: tllShadow,
    start: `35% 25%`,
    end: `50% 25%`,
    scrub: 2,
    // markers: true,
  })

  tllShadowTL1.to(tllShadow, { opacity: 1 });

  /**
   * 影 2クール
   */
  let tllShadowTL2 = gsap.timeline();

  ScrollTrigger.create({
    animation: tllShadowTL2,
    trigger: tllShadowInner,
    start: `50% 25%`,
    end: `75% 25%`,
    scrub: 1,
    // markers: true,
  })

  tllShadowTL2.to(tllShadowInner, { opacity: 1 });
}

/**
 * 
 * __00: 実行
 * 
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function ScrollAnimation() {
  if (!window.document.body.classList.contains("home")) {
    tllShadow();
  } else {
    homeScroll()
  }
}

export { ScrollAnimation }